import { useProjects, type Project } from '@/modules/Projects/useProjects'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export type CaseSortValue = 'createdAt' | 'updatedAt' | 'name' | 'id'

export const useDashboardFilterStore = defineStore('dashboardFilter', () => {
  const projectStore = useProjects()

  const searchValue = ref<string>('')
  const isSearchbarActive = ref(false)
  const caseOwnerIds = ref<string[]>([])
  const caseSortValue = ref<CaseSortValue>('name')
  const caseSortDirection = ref<'asc' | 'desc'>('asc')

  const filteredProjects = computed(() => {
    const lowerCasedSearchValue = searchValue.value?.toLowerCase()
    return projectStore.projects.filter((p: Project) => {
      if (!p) {
        return
      }
      const matchName = p.name?.toLowerCase().includes(lowerCasedSearchValue)
      const matchDescription = p.description?.toLowerCase().includes(lowerCasedSearchValue)
      const matchNoDescription = !p.description && searchValue.value?.trim() === 'No description'

      return matchName || matchDescription || matchNoDescription
    })
  })

  const setSearchValue = (value: string) => {
    searchValue.value = value
  }

  const setSearchbarActive = (value: boolean) => {
    isSearchbarActive.value = value
  }

  const setCaseOwnerIds = (value: string[]) => {
    caseOwnerIds.value = value
  }

  const setCaseSortValue = (value: CaseSortValue) => {
    caseSortValue.value = value
  }

  const setCaseSortDirection = (value: 'asc' | 'desc') => {
    caseSortDirection.value = value
  }

  const clear = () => {
    setSearchValue('')
    setSearchbarActive(false)
  }

  return {
    filteredProjects,
    searchValue,
    isSearchbarActive,
    caseSortValue,
    caseSortDirection,
    caseOwnerIds,
    setSearchValue,
    setCaseOwnerIds,
    setSearchbarActive,
    setCaseSortValue,
    setCaseSortDirection,
    clear,
  }
})
